import BaseService from "./geral/BaseService";
import {urlApi} from "../config/Constantes";
import {objetoParaQueryString} from "../utils/formatar";

const base = "Sailing";
const cntrManter = "AgendCntrManter";
const cntrConsulta = "AgendCntrConsulta";

const agendDash = "AgendCntrDashboard";

export default class AgendamentoDashboardService extends BaseService {
    constructor() {
        super(base);
    }

    listarOperacoes (dataInicial, dataFinal){
        return super.httpGet(`/${base}/ListarOperacoes?dataInicial=${dataInicial}&dataFinal=${dataFinal}&tamanhoPagina=${this.tamanhoPagina}`);
    }

    relatorio (operacao){
        return `${urlApi}/${base}/Relatorio/${operacao}`
    }

    listarFainas() {
        return super.httpGet(`/${cntrManter}/ListarFainas`);
    }
    
    listarDashboardDados(agendTipo, data) {
        return super.httpGet(`/${agendDash}/ListarDashboard/${agendTipo}/${data}`);
    }

    listarTipoAgendamento() {
        return super.httpGet(`/${cntrConsulta}/ListarTipos`);
    }
    
    listarHoras(tipoAgendId, data) {
        return super.httpGet(`/${cntrManter}/ListarHorasDisponiveisPorTipoData/${tipoAgendId}/${data}`);
    }

    ListarVeiculosConsulta = () => {
        return super.httpGet(`/${agendDash}/ListarVeiculosLiberados`);
    }
}



// WEBPACK FOOTER //
// ./src/services/AgendamentoDashboardService.js